import ApplicationFormMixin from '@/common/mixins/applicationFormMixin';

export default {
  mixins: [
    ApplicationFormMixin
  ],

  props: {
    visitorIndex: {
      type: Number,
      required: true
    },

    visitor: {
      type: Object,
      required: true
    },

    typeaheads: {
      type: Object,
      default: () => {
      }
    },

    transportIndex: {
      type: Number
    }
  },

  computed: {
    inputError () {
      if (this.isPassKindTransport) {
        return this.getErrorVisitorTransportDriver(this.visitorIndex, this.transportIndex, this.inputName)
      }

      return this.getErrorVisitor(this.visitorIndex, this.inputName)
    },

    hasInputErrors () {
      if (this.isPassKindTransport) {
        return this.hasErrorVisitorTransportDriver(this.visitorIndex, this.transportIndex, this.inputName)
      }

      return this.hasErrorVisitor(this.visitorIndex, this.inputName)
    }
  }
}
